<script lang="ts">
  import type { ProgressStepContext } from "@kontextwerk/web-sdk/ui/navigation/ProgressSteps.svelte"
  import type {
    DemoResetProfileDraft,
    DemoResetProfileOutput,
  } from "../../_shared/_logic/demo-data-reset-contract"
  import DemoAccessProfileStep from "../../_shared/_modules/demo-access-profile-step"

  const {
    ctx,
    initial,
    loading = false,
    loadError = "",
    onRetry,
    output = null,
    onOutput,
    onEdit,
  }: {
    ctx: ProgressStepContext
    initial: DemoResetProfileDraft | null
    loading?: boolean
    loadError?: string
    onRetry: () => void
    output?: DemoResetProfileOutput | null
    onOutput: (output: DemoResetProfileOutput) => void
    onEdit: () => void
  } = $props()
</script>

<DemoAccessProfileStep
  {ctx}
  title="Chef-Zugang"
  description="Legen Sie Anmeldung und Ansprechpartner-Kontaktdaten für den Chef fest."
  helpModalTextId="organizationTestDataChef"
  actionBoxLabel="Chef konfigurieren"
  roleDescription="Der Chef erhält administrative Rechte und betreut die erste Hälfte der Beispiel-Liegenschaften."
  {initial}
  {loading}
  {loadError}
  {onRetry}
  {output}
  {onOutput}
  {onEdit}
/>
